import { Component } from '@angular/core'
import { MatCard } from '@angular/material/card'
import { MatDialogClose } from '@angular/material/dialog'
import { MatIcon } from '@angular/material/icon'

@Component({
  selector: 'dialog-password',
  imports: [MatCard, MatDialogClose, MatIcon],
  templateUrl: './dialog-password.component.html',
  styleUrl: './dialog-password.component.scss',
})
export class DialogPasswordComponent {}
